/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable quote-props */
import {
  Directive,
  HostListener,
  Input,
  ElementRef,
  OnInit,
  EventEmitter,
  Output,
} from '@angular/core';

const placeholders = {
  A: '^[a-zA-ZA-zА-яЁё]',
  '0': '\\d',
};

const keys = {
  BACKSPACE: 8,
  LEFT: 37,
  RIGHT: 39,
  DEL: 46,
};

interface IState {
  value: string;
}

@Directive({
    // tslint:disable:directive-selector
    // disabling lint here because this isn't really specific to this application
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[mask]',
    standalone: false
})
export class InputMaskDirective implements OnInit {
  private state: IState;

  @Input() mask: any;
  @Output() ngModelChange = new EventEmitter();

  /**
   *
   * @param element
   * @param model
   */
  constructor(private element: ElementRef) {
    this.state = {
      value: this.getValue(),
    };
  }

  /**
   *
   */
  @HostListener('focus')
  public onInit(): void {
    if (this.inputTooLongForMask()) {
      return;
    }
    this.applyMask(this.getClearValue(this.getValue()));
  }

  /**
   *
   */
  @HostListener('input')
  public onChange(): void {
    if (this.inputTooLongForMask()) {
      return;
    }
    this.applyMask(this.getClearValue(this.getValue()));
  }

  /**
   *
   * @param event
   */
  @HostListener('keypress', ['$event'])
  public onKeyPress(event): void {
    const key = this.getKey(event);
    if (key === keys.BACKSPACE || key === keys.LEFT || key === keys.RIGHT) {
      return;
    }

    const cursorPosition = this.getCursorPosition();
    const regexp = this.createRegExp(cursorPosition);
    if (
      (regexp != null && !regexp.test(event.key)) ||
      this.getValue().length >= this.mask.length
    ) {
      event.preventDefault();
    }
  }

  /**
   *
   * @param event
   */
  @HostListener('keydown', ['$event'])
  public onKeyDown(event): void {
    const key = this.getKey(event);
    if (
      (key === keys.BACKSPACE || key === keys.DEL) &&
      this.getClearValue(this.getValue()).length === 1
    ) {
      this.setValue('');
      this.state.value = '';
      this.ngModelChange.emit('');
    }
  }

  /**
   *
   */
  public ngOnInit(): void {
    if (this.inputTooLongForMask()) {
      return;
    }
    this.applyMask(this.getClearValue(this.getValue()));
  }

  /**
   *
   * @param event
   * // @returns {number}
   */
  private getKey(event) {
    return event.keyCode || event.charCode;
  }

  /**
   *
   * @param value
   */
  private applyMask(value): void {
    let newValue = '';
    let maskPosition = 0;

    if (this.inputTooLongForMask()) {
      this.setValue(this.state.value);
      return;
    }

    for (let i = 0; i < value.length; i++) {
      const current = value[i];

      const regexp = this.createRegExp(maskPosition);
      if (regexp != null) {
        if (!regexp.test(current)) {
          this.setValue(this.state.value);
          break;
        }
        newValue += current;
      } else if (this.mask[maskPosition] === current) {
        newValue += current;
      } else {
        newValue += this.mask[maskPosition];
        i--;
      }

      maskPosition++;
    }

    const nextMaskElement = this.mask[maskPosition];
    if (
      value.length &&
      nextMaskElement != null &&
      /^[-\/\\^$#&@№:<>_\^!*+?.()|\[\]{}]/.test(nextMaskElement)
    ) {
      newValue += nextMaskElement;
    }

    const oldValue = this.state.value;
    const cursorPosition = this.getCursorPosition();
    this.setValue(newValue);
    this.state.value = newValue;

    if (oldValue.length >= cursorPosition) {
      this.setCursorPosition(cursorPosition);
    }
  }

  /**
   *
   * @param position
   * // @returns {any}
   */
  private createRegExp(position): RegExp | null {
    if (this.mask[position] == null) {
      return null;
    }

    const currentSymbol = this.mask[position].toUpperCase();
    const placeholderKeys = Object.keys(placeholders);
    const searchPosition = placeholderKeys.indexOf(currentSymbol);
    if (searchPosition >= 0) {
      return new RegExp(placeholders[placeholderKeys[searchPosition]], 'gi');
    }
    return null;
  }

  /**
   *
   * // @returns {any}
   */
  private getValue(): string {
    return this.element.nativeElement.value;
  }

  /**
   *
   * @param value
   * // @returns {string}
   */
  private getClearValue(value): string {
    return value.trim().replace(/[-\/\\^$#&@№:<>_\^!*+?.()|\[\]{}]/gi, '');
  }

  /**
   *
   * @param value
   */
  private setValue(value: string): void {
    this.element.nativeElement.value = value;
  }

  /**
   *
   * // @returns {number}
   */
  private getCursorPosition(): number {
    return this.element.nativeElement.selectionStart;
  }

  /**
   *
   * @param start
   * @param end
   */
  private setCursorPosition(start: number, end: number = start): void {
    this.element.nativeElement.setSelectionRange(start, end);
  }

  private inputTooLongForMask(): boolean {
    const inputValueLength = this.getClearValue(this.getValue()).length;
    const maskLength = this.getClearValue(this.mask).replace(/ /g, '').length;
    return inputValueLength > maskLength;
  }
}
